/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Show_Differences_OnlyInputs */

const en_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show differences only`)
};

const fr_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher uniquement les différences`)
};

const de_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Unterschiede anzeigen`)
};

const it_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra solo le differenze`)
};

const ru_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать только различия`)
};

const es_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar solo diferencias`)
};

const zh_cn2_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅显示差异`)
};

const ja_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相違点のみ表示`)
};

const hi_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल अंतर दिखाएँ`)
};

const pt_pt2_compare_event_groups_show_differences_only = /** @type {(inputs: Compare_Event_Groups_Show_Differences_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar apenas as diferenças`)
};

/**
* | output |
* | --- |
* | "Show differences only" |
*
* @param {Compare_Event_Groups_Show_Differences_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_show_differences_only = /** @type {((inputs?: Compare_Event_Groups_Show_Differences_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Show_Differences_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_show_differences_only(inputs)
	if (locale === "de") return de_compare_event_groups_show_differences_only(inputs)
	if (locale === "it") return it_compare_event_groups_show_differences_only(inputs)
	if (locale === "ru") return ru_compare_event_groups_show_differences_only(inputs)
	if (locale === "es") return es_compare_event_groups_show_differences_only(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_show_differences_only(inputs)
	if (locale === "ja") return ja_compare_event_groups_show_differences_only(inputs)
	if (locale === "hi") return hi_compare_event_groups_show_differences_only(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_show_differences_only(inputs)
	return en_compare_event_groups_show_differences_only(inputs)
});